import { FundingProgressIndicator } from '../FundingProgressIndicator/FundingProgressIndicator';
import { FlexiApprovedView } from './FlexiApprovedView/FlexiApprovedView';

export const ApprovedView = () => {
    return (
        <div className="bg-structure-100">
            <div className="m-auto max-w-[610px]">
                <FundingProgressIndicator step={2} />
                <FlexiApprovedView />
            </div>
            {/* TODO @k.anyabuike: Implement summary section here */}
        </div>
    );
};
